<template>
    <div class="videoCard" @click="openVideo">
        <img :src="videoData.Cover" :height="imgHeight">
        <p class="title">{{videoData.Title}}</p>
        <p class="preview">{{videoData.Description}}</p>
    </div>
</template>
<script>
export default {
  name: "videoCard",
  props: {
    videoData: {
      type: Object
    },
    imgHeight: {
      type: String
    }
  },
  methods: {
    openVideo() {
      this.$router.push({
        path: "/emrClass/detail",
        query: { id: encodeURIComponent(this.videoData.Id) }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.videoCard {
  border-width: 1px;
  border-style: solid;
  border-color: rgba(245, 245, 245, 1);
  border-radius: 3px;
  padding-bottom: 10px;
  cursor: pointer;
  &:hover {
    opacity: 0.85;
    .icon-play {
      opacity: 0.9;
    }
  }
}
img {
  width: 100%;
}
.title {
  font-size: 20px;
  color: #333333;
  margin: 10px 15px;
}
.preview {
  font-size: 16px;
  color: #c5c5c7;
  margin: 10px 15px;
}
</style>
